import { useState } from 'react';
import ReferralModal from '@/components/portfolio/desktop/ReferralModal';
import { Button } from '@/components/ui/button';
import CustomDialog from '@/components/ui/customDialog';
import LogoutBtn from '@/components/userSettings/LogoutBtn';
import AccountController from '@/components/account/desktop';
import MobileAppModal from '@/components/layout/modal/MobileAppModal';
import Deposit from '@/components/deposit';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
export default function LoggedInUserMenu({
  PFP
}) {
  const [showAccount, setShowAccount] = useState(false);
  const [accountModal, setAccountModal] = useState(false);
  const [isOpenRefer, setIsOpenRefer] = useState(false);
  function toggleModal() {
    setIsOpenRefer(!isOpenRefer);
  }
  return <div className='w-fit mx-auto flex items-center gap-1' data-sentry-component="LoggedInUserMenu" data-sentry-source-file="LoggedInUserMenu.tsx">
      <Button onClick={toggleModal} className='w-[100px] h-[32px] rounded-full bg-genius-pink hover:opacity-80 transition-opacity text-[16px] text-genius-blue' variant='ghost' data-sentry-element="Button" data-sentry-source-file="LoggedInUserMenu.tsx">
        Refer
      </Button>
      <CustomDialog hideClose={true} className={'p-0'} toggleModal={toggleModal} isOpen={isOpenRefer} data-sentry-element="CustomDialog" data-sentry-source-file="LoggedInUserMenu.tsx">
        <ReferralModal toggleModal={toggleModal} data-sentry-element="ReferralModal" data-sentry-source-file="LoggedInUserMenu.tsx" />
      </CustomDialog>

      <CustomDialog className={'h-fit w-[572px]'} trigger={<Button className='w-[100px] h-[32px] rounded-full bg-genius-blue hover:opacity-80 transition-opacity text-[16px] text-genius-cream' variant='ghost'>
            Deposit
          </Button>} data-sentry-element="CustomDialog" data-sentry-source-file="LoggedInUserMenu.tsx">
        <Deposit data-sentry-element="Deposit" data-sentry-source-file="LoggedInUserMenu.tsx" />
      </CustomDialog>

      <div className='flex items-center' onMouseEnter={() => setShowAccount(true)} onMouseLeave={() => setShowAccount(false)}>
        <Button className='w-[120px] h-[32px] rounded-full bg-genius-blue hover:bg-genius-blue text-[16px] text-genius-cream ml-2' variant='ghost' data-sentry-element="Button" data-sentry-source-file="LoggedInUserMenu.tsx">
          <ImageWithFallback src={PFP} alt='user' height={32} width={32} className='rounded-full ml-[-20px] mr-2' data-sentry-element="ImageWithFallback" data-sentry-source-file="LoggedInUserMenu.tsx" />
          Account
        </Button>
        {showAccount && <div className='w-[393px] h-[200px] z-50 border-genius-blue border-[1px] rounded-[20px] bg-genius-indigo flex flex-col justify-start p-4 pt-6 term absolute top-[50px] right-2 genius-shadow'>
            <div className='flex items-center h-fit w-full hover:bg-genius-purple rounded-[10px] p-2'>
              <ImageWithFallback src={PFP} alt='user' height={32} width={32} className='mr-[-20px] z-[2] rounded-full' />
              <div onClick={() => {
            setShowAccount(false);
            setAccountModal(true);
          }} className='w-[400px] whitespace-nowrap rounded-full cursor-pointer text-[16px] text-genius-cream pl-8'>
                Settings
              </div>
            </div>
            <MobileAppModal />
            <div className='w-[92%] absolute bottom-2'>
              <LogoutBtn />
            </div>
          </div>}

        {(showAccount || accountModal) && <CustomDialog className={'w-[637px] h-[626px]'} toggleModal={() => {
        setAccountModal(!accountModal);
        setShowAccount(false);
      }} isOpen={accountModal}>
            <AccountController />
          </CustomDialog>}
      </div>
    </div>;
}